import req from '../http';
import urls from '../../utils/config';
const baseURL = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_URL: urls['url']

//查询用户名称和物料信息
export const queryRegFeeInfo = params => req('post', '/carOrder/registrationFee/queryRegFeeInfo', params,{
    baseURL,
}); // 获取出行券列表
//查询用户名称和物料信息
export const queryRegFeeOrderList = params => req('post', '/carOrder/registrationFee/queryRegFeeOrderList', params,{
    baseURL,
}); // 获取出行券列表